// src/ui/TopBar.js
import React from "react";
import { useNavigate } from "react-router-dom";
import siteLogo from "../assets/logo_cofounder_hub_logo_light-no-border.svg";
import "../styles.css";

function TopBar({ currentTab }) {
    const navigate = useNavigate();

    return (
        <header style={{ backgroundColor: "#1b3448", minHeight: "104px", display: "flex", alignItems: "center" }}>
            <div
                style={{
                    maxWidth: "1190px",
                    width: "100%",
                    margin: "0 auto",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    paddingLeft: "20px",
                    paddingRight: "20px",
                    height: "100%",
                }}
            >
                {/* Logo on the left */}
                <a
                    href="https://thecofoundershub.com"
                    style={{ textDecoration: "none", display: "flex", alignItems: "center" }}
                >
                    <img src={siteLogo} alt="The Cofounders Hub" style={{ height: "60px", width: "auto" }} />
                </a>

                {/* Centered navigation */}
                <nav style={{ flex: 1, display: "flex", justifyContent: "center", alignItems: "center", gap: "32px" }}>
                    <button
                        onClick={() => navigate("/home")}
                        className={`topbar-btn ${currentTab === "home" ? "active" : ""}`}
                    >
                        Home
                    </button>
                    <button
                        onClick={() => navigate("/calculator")}
                        className={`topbar-btn ${currentTab === "calculator" ? "active" : ""}`}
                    >
                        Equity Calculator
                    </button>
                    <button
                        onClick={() => navigate("/report")}
                        className={`topbar-btn ${currentTab === "report" ? "active" : ""}`}
                    >
                        Report
                    </button>
                </nav>
            </div>
        </header>
    );
}

export default TopBar;
